<template>
  <div style="padding:56px 0px;">
    <div style="padding:20px;">
      <div class="mycard hbox">
      <div>
        <div class="title1">{{user.name}} (账户ID:{{user.icode}}) </div>
        <div class="title2">总资产折合(CNY)</div>
        <div class="title1" style="font-size:2rem;">{{user.balance | formatnumber}}</div>
      </div>
     <div >
            <div class="title1"></div>
            <br>
            <div class="title2">今日盈亏</div>
            <div class="title2">{{windata.totalwin |formatnumber }}</div>
      </div> 
     <!--  <div >
            <div class="title1"></div>
            <br>
            <div class="title2">信用分</div>
            <div class="title1" style="font-size:2rem;">{{user.xinyongfen}}</div>
      </div> -->
      </div>

      <br>
      <br>

      <div class="hbox space-evenly">
        <div class="iconbutton" @click="buy">
          <img src="static/icons/qianbao.png" />
          <div>充值</div>
        </div>
        <div class="iconbutton" @click="gotoTixian">
          <img src="static/icons/libao.png" />
          <div>提现</div>
        </div>
        
        <div class="iconbutton" @click="jiaoyi">
          <img src="static/icons/huodong.png" />
          <div>行情记录</div>
        </div>

        <div class="iconbutton" @click="cz">
          <img src="static/icons/user-tx.png" />
          <div>充值记录</div>
        </div>
      </div>
    
      <div class="hbox space-evenly">
        <div class="iconbutton" @click="tx">
          <img src="static/icons/user-tz.png" />
          <div>提现记录</div>
        </div>
        <div class="iconbutton" @click="jy">
          <img src="static/icons/user-zd.png" />
          <div>买入记录</div>
        </div>

         <div class="iconbutton" @click="gm">
          <img src="static/icons/xiugai_mima.png" />
          <div>修改密码</div>
        </div>
  
            <div class="iconbutton" @click="tokefu">
          <img src="static/icons/chat.png" />
          <div>在线客服</div>
        </div>



      
  
      </div>
      <div class="hbox space-evenly" >
         <div class="iconbutton" @click="bd">
          <img src="static/icons/bank.png" />
          <div>银行卡</div>
        </div>

         <div class="iconbutton" @click="qb">
          <img src="static/icons/bank.png" />
          <div>USDT钱包</div>
        </div>
        
          <div class="iconbutton" @click="shiming">
          <img src="static/icons/mimasuo-.png" />
          <div>实名认证</div>
        </div> 

         <div class="iconbutton" @click="zj">
          <img src="static/icons/mimasuo-.png" />
          <div>资金密码</div>
        </div>
        </div>
        <div class="hbox space-evenly" >
           <div class="iconbutton" @click="logout">
          <img src="static/icons/tuichu.png" />
          <div>退出</div>
        </div>
        </div>
      </div>
     <!--  <div style="text-align:left;">
        <div class="myblue" style="padding:10px 0px;">CNY</div>

        <div class="columns is-mobile">
          <div class="column">
            <div class="mygray">可用</div>
            <div>{{user.balance | formatnumber}}</div>
          </div>
         <div class="column" v-if="show_dongjie">
            <div class="mygray">冻结</div>
            <div>0.00</div>
          </div> 
          <div class="column">
            <div class="mygray">折合(CNY)</div>
            <div>{{user.balance/huilv | formatcny}}</div>
          </div>
        </div>
      </div>

      <div style="text-align:left;" v-for="item in user.assets" :key="item.code">
        <div class="myblue" style="padding:10px 0px;">{{item.code.toUpperCase()}}</div>

        <div class="columns is-mobile">
          <div class="column">
            <div class="mygray">可用</div>
            <div>{{item.balance | formatnumber}}</div>
          </div>
         <div class="column" v-if="show_dongjie" >
            <div class="mygray">冻结</div>
            <div>0.00</div>
          </div> 
          <div class="column">
            <div class="mygray">折合(CNY)</div>
            <div>{{item.balance*getvalue(item.code)/huilv | formatcny}}</div>
          </div>
        </div>
      </div> -->
    </div>
  
</template>
<script>
import Util from '@/utils'
export default {
  data() {
    return {
      huilv: 1
    };
  },
  filters: {
    formatnumber(value) {
      return value.toFixed(2);
    },
    formatcny(value) {
      return value.toFixed(2);
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    currencys(){
      return this.$store.state.currencylist
    },
    windata() {
      return this.$store.state.windata;
    },
    show_dongjie() {
      return this.$store.state.show_dongjie;
    }
  },
  beforeRouteEnter (to, from, next) {
    
    next((vm)=>{
      vm.$store.dispatch("getUserInfo")
    })
  },
  methods: {
    getvalue(code){
      if(this.$store.state.currencylist[code])
      {
         return this.$store.state.currencylist[code].price
       }
       return 0;
    },
    gotoTixian()
   {
        this.$router.push("/tixianmode")
   },
    tixian() {
      if(this.$store.state.user.tixianpass.length<2){
          this.$toast("为了您的资金安全,请设置资金密码")
          this.$router.push("/tixianpass")
        return ;
      };
      if(this.$store.state.user.hasOwnProperty("bankinfo") && this.$store.state.user.bankinfo.banknumber.length>5){
        this.$router.push("/tixian");
        return;
      }
      else {
        this.$toast("请绑定银行卡")
        this.$router.push("/addbank")
      }
      
    },
      tixian2() {
      if(this.$store.state.user.tixianpass.length<2){
          this.$toast("为了您的资金安全,请设置资金密码")
          this.$router.push("/tixianpass")
        return ;
      };
      if(this.$store.state.user.hasOwnProperty("wallet") && this.$store.state.user.wallet.walletAddress.length>5){
        this.$router.push("/tixian");
        return;
      }
      else {
        this.$toast("请绑定USDT钱包")
        this.$router.push("/wallet")
      }
      
    },

    buy() {
      //window.toService();
      this.$router.push("/kefu");
    },
    gm(){
       this.$router.push("/resetpass")
    },
    bd(){
       this.$router.push("/addbank")
    },
    zj(){
      this.$router.push("/tixianpass")
    },
    qb(){
      this.$router.push("/wallet")
    },
    jiaoyi() {
      //window.toTrade()
      this.$router.push("/openrecords")
      //this.$router.push("/home/tradeview/cro");
    },
    shiming() {

      if(this.$store.state.user.auth_state==2) {
        this.$toast("认证审核中,请稍后查看")
      }
      else if (this.$store.state.user.auth_state==1) {
        this.$router.push("/auth")
      }
      else {
         this.$toast("你已完成实名认证")
      }

      
    },
    tokefu()
    {
        this.$router.push("/kefu")
    },
    cz() {
      this.$router.push("/rechargerecords");
    },
    tx() {
      this.$router.push("/tixianrecords");
    },
    jy() {
      this.$router.push("/betrecords");
    },
    logout(){
      this.$store.state.user=null;
      this.$store.state.windata = {}
      Util.setToken("")
      this.$router.push("/login");
      window.location.reload();
     
    }
  }
};
</script>
<style scoped>
.mycard {
  border-radius: 20px 20px 0 0;
  background: #1882d4;
  color: white;
  padding: 15px;
  text-align: left;
}
.title1 {
  font-size: 1rem;
  font-weight: bold;
}
.title2 {
  font-size: 0.6rem;
  color: #e8e8e8;
}
.myblue {
  color: skyblue;
}
.mygray {
  color: #a8a8a8;
}
.column {
  padding-left:0.5rem;
}
.iconbutton {
  width: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
 
}
.iconbutton img {
  width: 48px;
  height: 48px;
  padding: 10px;
}
.space-evenly {
  justify-content: space-between;
}
.flex-start {
  justify-content: flex-start;
}
</style>


// WEBPACK FOOTER //
// src/pages/My.vue